// extracted by mini-css-extract-plugin
module.exports = {"HiddenFileInput":"UploadMedia_HiddenFileInput__28u9Q"};